import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { DeleteConventionRegistrationHistory } from 'app/models/delete-convention-registration-history.model';
import { LOVConventionRegistrationTypeExtension } from 'app/models/extensions/lov-convention-registration-type-extension.model';
import { MRMValidators } from '@mrm/core';

export class LOVConventionRegistrationType extends LOVConventionRegistrationTypeExtension {
  conventionRegistrationTypeDBID: number = 0;
  legacyCode: string = null;
  englishDescription: string = null;
  frenchDescription: string = null;
  isActive?: boolean = null;
  orderNumber: number = 0;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionRegistrations: ConventionRegistration[] = [];
  deleteConventionRegistrationHistories: DeleteConventionRegistrationHistory[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      conventionRegistrationTypeDBID: new FormControl({ value: 0, disabled: disableAll }),
      legacyCode: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(2)]),
      englishDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      frenchDescription: new FormControl({ value: null, disabled: disableAll }, [Validators.required, Validators.maxLength(255)]),
      isActive: new FormControl({ value: null, disabled: disableAll }),
      orderNumber: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      conventionRegistrations: new FormArray([]),
      deleteConventionRegistrationHistories: new FormArray([])
    });


    return form;
  }
}